import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SiteApi from '../../Api/SiteApi/SiteApi';
import Loader from '../loader/Loader';

import KenoPlay from './Keno/KenoPlay';
import LotteryPlay from './Lottery/LotteryPlay';
import PickPlay from './Pick/PickPlay';
import SoccerPlay from './Soccer/SoccerPlay';
import { LotteryTypes } from './Types/Enums';
import { findGameType } from './helpers/pickHelper';
import { RootState } from './redux/store';
import * as action from './redux/storeSlice';

export default function Play({ slug }: Readonly<{ slug: string }>) {
    const dispatch = useDispatch();
    const { lottery } = useSelector((state: RootState) => state.playStore);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        SiteApi.getPlayData(slug).then((data) => {
            dispatch(action.setLottery(data.lottery));
            dispatch(action.setLines(data.selectedLines));
            dispatch(action.setPrice(data.price));
            dispatch(action.setGameType(data.gameType));
            dispatch(action.setGameTypes(data.gameTypes));
            dispatch(action.setDisplayDrawCounter(data.displayDrawCounter));
            dispatch(action.setResellerOptionsEnabled(data.resellerOptionsEnabled));
            dispatch(action.setResellerCustomers(data.resellerCustomers));
            dispatch(action.setMultiDrawTicketPackets(data.multiDrawTicketPackets));
            dispatch(action.setNextDrawNumber(Number(data.nextDrawNumber)));
            dispatch(action.setStakeMin(Number(data.stakeMin)));
            dispatch(action.setStakeMax(Number(data.stakeMax)));
            dispatch(action.setNextDraw(data.nextDraw));
            dispatch(action.setNextNextDraw(data.nextNextDraw));
            dispatch(action.setSelectableDrawDateTimes(data.selectableDrawDateTimes));
            dispatch(action.setTicketPriceMin(data.ticketPriceMin));
            dispatch(action.setTicketPriceMax(data.ticketPriceMax));

            const queryParams = new URLSearchParams(window.location.search);

            if (queryParams.has('game')) {
                const gameType = findGameType(queryParams.get('game'), data.gameTypes);

                if (gameType) {
                    dispatch(action.setGameType(gameType));
                }
            }

            if (queryParams.has('multiplier')) {
                dispatch(action.setMultiplier(Number(queryParams.get('multiplier'))));
            }

            setIsLoading(false);
        });
    }, []);

    const getPicker = () => {
        switch (lottery.type) {
            case LotteryTypes.Pick:
                return <PickPlay />;

            case LotteryTypes.Soccer:
                return <SoccerPlay />;

            case LotteryTypes.Lottery:
                return <LotteryPlay />;

            case LotteryTypes.Keno:
                return <KenoPlay />;

            default:
                console.error(`Lottery type "${lottery.type}" is not supported by this picker.`);
        }

        return null;
    };

    return <Loader isLoading={isLoading} elementToShow={getPicker} />;
}
